import { POST } from '@/api'
import { cloneDeep, isEqual, pick } from 'lodash'

const initial = {
  id: null,
  name: '',
  description: '',
  price: null,
}

export default {
  namespaced: true,
  state: {
    busy: false,
    course: {},
    courseDetail: {},
    allIds: [],
  },
  mutations: {
    set(state, courses) {
      state.course = cloneDeep(courses.byId)
      state.allIds = courses.allIds
    },
    setDetail(state, course = initial) {
      state.courseDetail = course
    },
    busy(state, busy) {
      state.busy = busy
    },
    update(state, course) {
      state.course[course.id] = { ...state.course[course.id], ...course }
    },
    updateCourseDetail(state, detail) {
      state.courseDetail = { ...state.courseDetail, ...detail }
    },
    updateUseReception(state, value) {
      state.allIds.forEach(id => {
        state.course[id].useReception = value.includes(id)
      })
    },
    updateTaxType(state, tax) {
      state.allIds.forEach(id => {
        state.course[id].tax = tax
      })
    },
  },
  getters: {
    all: state => state.allIds.map(id => state.course[id]),
    selectedCourses: ({ course, allIds }) => allIds.filter(id => course[id].useReception).sort(),
    changed: ({ course }, _, { courses }) => !isEqual(course, courses.byId),
    changedCourseDetail: ({ courseDetail }, _, { courses }) =>
      !isEqual(courseDetail, courseDetail.id ? courses.byId[courseDetail.id] : initial),
  },
  actions: {
    async init(store) {
      const { commit, rootState } = store
      commit('set', rootState.courses)
    },
    async start({ commit, rootState }, id) {
      commit('setDetail', id ? rootState.courses.byId[id] : initial)
    },
    async save(store) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const keys = ['id', 'useReception', 'tax']
      const data = state.allIds.map(id => {
        const obj = pick(state.course[id], keys)
        obj.english = state.course[id].names.eng || null
        return obj
      })

      const { status, message } = await POST('/api/web/reception/course/update', { courses: data })
      if (status === 200) {
        commit('courses/set', cloneDeep(state.allIds.map(id => state.course[id])), { root: true })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async saveCourseDetail({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { id, names, description, price } = state.courseDetail
      const { status, message } = await POST('/api/web/v2/course/register', {
        id,
        name: names.jpn,
        description,
        price: price || 0,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
